import { render, staticRenderFns } from "./folderUpdat.vue?vue&type=template&id=0d5c9db8&scoped=true"
import script from "./folderUpdat.vue?vue&type=script&lang=js"
export * from "./folderUpdat.vue?vue&type=script&lang=js"
import style0 from "./folderUpdat.vue?vue&type=style&index=0&id=0d5c9db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5c9db8",
  null
  
)

export default component.exports